import { ChangeDetectorRef, Component, ComponentFactoryResolver, Input, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { FilterAdministrationContext } from '../../filter-administration.context';
import { FilterCondition, EditorFilterTreeNode } from '../../filter-administration.model';
import { FilterDetailsComponent } from '../../filter-details-component.model';
import { FilterEditorRegistryService } from '../../filter-editor-registry.service';
import { CarrierConditionEditorComponent } from './transport/carrier-condition-editor/carrier-condition-editor.component';
import { FilterNodeEditorComponent } from './filter-node-editor/filter-node-editor.component';

const source = 'app-details-editor-wrapper';

@Component({
  selector: 'app-details-editor-wrapper',
  templateUrl: './details-editor-wrapper.component.html',
  styleUrls: ['./details-editor-wrapper.component.scss']
})
export class DetailsEditorWrapperComponent implements OnInit, OnDestroy {

  @ViewChild('ref', { read: ViewContainerRef })
  ref: ViewContainerRef;

  filterAdministrationContext: FilterAdministrationContext;
  filterAdministrationContextSubscription: Subscription;

  private selectedFilterCondition: FilterCondition;
  private selectedFilterNode: EditorFilterTreeNode;

  @Input() set setfilterAdministrationContext(filterAdministrationContext: FilterAdministrationContext) {
    this.filterAdministrationContext = filterAdministrationContext;
    this.filterAdministrationContextSubscription = this.filterAdministrationContext.contextChange$.subscribe(
      change => {
        try {
          if (change.key === 'selected-filter-condition-changed') {
            this.selectedFilterCondition = change.value;
            this.selectedFilterNode = null;
            this.createComponent();
          }
          if (change.key === 'selected-filter-node-changed') {
            this.selectedFilterNode = change.value;
            this.selectedFilterCondition = null;
            this.createComponent();
          }
        } catch (error) {

        }
      }
    );
  }

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private changeDetectorRef: ChangeDetectorRef,
    private filterEditorRegistryService: FilterEditorRegistryService
  ) { }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    if (this.filterAdministrationContextSubscription != null) {
      this.filterAdministrationContextSubscription.unsubscribe();
    }
  }

  createComponent() {

    // console.log('creating widget for element', this.selectedFilterCondition);

    while (this.ref.length > 0) {
      this.ref.remove(0);
    }

    if (this.selectedFilterNode != null) {

      const factory = this.componentFactoryResolver.resolveComponentFactory(FilterNodeEditorComponent);
      const componentRef = this.ref.createComponent<FilterNodeEditorComponent>(factory);
      componentRef.instance.setFilterAdministrationContext(this.filterAdministrationContext);

    } else if (this.selectedFilterCondition != null) {
      const editor = this.filterEditorRegistryService.getEditor(this.selectedFilterCondition.type);
      if (editor != null) {
        const factory = this.componentFactoryResolver.resolveComponentFactory(editor.editorComponent);
        const componentRef = this.ref.createComponent<FilterDetailsComponent>(factory);
        componentRef.instance.setFilterAdministrationContext(this.filterAdministrationContext);
      }

      this.changeDetectorRef.detectChanges();
    }
  }

}
